import React from 'react';
import { Button } from '../ui/button';
import { RefreshCw, Trash2, Loader2 } from 'lucide-react';

const SlideEditPanel = ({ slide, slideIndex, onUpdate, onRegenerate, onDelete, regenerating, totalSlides }) => (
  <div data-testid={`edit-panel-slide-${slideIndex}`} className="bg-white rounded-2xl border border-stone-100 p-5 space-y-4">
    <div className="flex items-center justify-between">
      <h4 className="font-sans font-bold text-stone-800 text-sm">Edit lysbilde {slideIndex + 1}</h4>
      <div className="flex items-center gap-2">
        <Button
          data-testid={`regenerate-slide-${slideIndex}`}
          onClick={() => onRegenerate(slideIndex)}
          disabled={regenerating}
          variant="outline"
          className="h-8 px-3 text-xs font-sans font-semibold rounded-full border-primary/30 text-primary hover:bg-primary/5"
        >
          {regenerating ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <RefreshCw className="w-3 h-3 mr-1" />}
          AI Regenerer
        </Button>
        {totalSlides > 1 && (
          <Button
            data-testid={`delete-slide-${slideIndex}`}
            onClick={() => onDelete(slideIndex)}
            variant="ghost"
            className="h-8 w-8 p-0 text-stone-400 hover:text-red-500"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </Button>
        )}
      </div>
    </div>
    <div>
      <label className="text-xs font-sans font-medium text-stone-500 mb-1 block">Heading</label>
      <input
        data-testid={`edit-slide-headline-${slideIndex}`}
        value={slide.headline || ''}
        onChange={(e) => onUpdate(slideIndex, { ...slide, headline: e.target.value })}
        className="w-full text-sm font-sans font-semibold text-stone-800 bg-stone-50 border border-stone-200 rounded-lg px-3 py-2 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none"
      />
    </div>
    <div>
      <label className="text-xs font-sans font-medium text-stone-500 mb-1 block">Undertekst</label>
      <input
        data-testid={`edit-slide-subtext-${slideIndex}`}
        value={slide.subtext || ''}
        onChange={(e) => onUpdate(slideIndex, { ...slide, subtext: e.target.value })}
        className="w-full text-sm font-sans text-stone-600 bg-stone-50 border border-stone-200 rounded-lg px-3 py-2 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none"
      />
    </div>
    <div>
      <label className="text-xs font-sans font-medium text-stone-500 mb-1 block">Lightbildetype</label>
      <div className="flex items-center gap-2 flex-wrap">
        {['hook', 'content', 'engagement', 'cta'].map((type) => (
          <button
            key={type}
            onClick={() => onUpdate(slideIndex, { ...slide, type })}
            className={`px-3 py-1.5 rounded-full text-xs font-sans font-semibold border transition-all ${
              slide.type === type ? 'border-primary bg-primary/5 text-primary' : 'border-stone-200 text-stone-500 hover:border-stone-300'
            }`}
          >
            {type}
          </button>
        ))}
      </div>
    </div>
  </div>
);

export default SlideEditPanel;
